export default {
    Chart: '图表',
    SaveAsimage: '保存为图片',
    Table: '表格',
    LineGraph: '折线图',
    BarGraph: '柱状图',
    PieChart: '饼图',
    Percentage: '占比：',
    ClearMemory: '清除记忆',
    ChatContextClearedSuccessfully: '清除对话上下文成功',
    FileUploadFailed: '文件上传失败',
    ImageUploadGailed: '图片上传失败',
    PleaseEnterTheChatContentPressShiftEnterToTtartANewLine: '请输入聊天内容，Shift+Enter换行',
    EnterMessage: '请输入聊天内容',
    PleaseEnterTheChatContent: '请输入聊天内容',
    KnowledgeBaseSource: '知识库来源：',
    DrawingInProgress: '正在绘画...',
    DatabaseExecution: '数据库执行',
    CopyCode: '复制代码',
    CopySuccessful: '复制成功',
    LongPressOnTheImageToSave: '长按图片可保存',
    TextCopy: '复制文字',
    VoiceRead: '语音朗读',
    PausePlayback: '暂停播放',
    IHeFoundTheAnswerForYou: '为你找到答案',
    ExecutionSuccessful: '执行成功',
    ExecutionFailed: '执行失败',
    RunningParameters: '运行参数',
    RunningResults: '运行结果',
    ReferencesFromSources: '篇结果来源参考资料',
    PlaybackFailed: '播放失败',
}